document.addEventListener('DOMContentLoaded', function () {
  var backToTop = document.getElementById('back-to-top');
  if (!backToTop) return;

  function toggleButton() {
    var scrollTop = window.scrollY || window.pageYOffset;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollPercent = docHeight > 0 ? scrollTop / docHeight : 0;

    // Show after 15% scroll (change 0.15 to 0.10 or 0.25 if you prefer)
    if (scrollPercent > 0.15) {
      backToTop.classList.remove('back-to-top--hidden');
    } else {
      backToTop.classList.add('back-to-top--hidden');
    }
  }

  window.addEventListener('scroll', toggleButton);
  toggleButton(); // run once on load
});